import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import React from "react";
import { renderStars } from "./PerformanceMetrics";
import { SectionCard } from "./SectionCard";
import { colors } from "./theme";

interface TopDriver {
  driver: {
    id: string;
    firstName: string;
    lastName: string;
    profilePicture: string;
  };
  completedJobs: number;
  averageRating: number;
}

interface TopDriversLeaderboardProps {
  topDrivers: TopDriver[];
}

export const TopDriversLeaderboard: React.FC<TopDriversLeaderboardProps> = ({
  topDrivers
}) => {
  return (
    <Grid xs={12} spacing={2}>
      <SectionCard title="Top Drivers Leaderboard" icon={<CheckCircleIcon />}>
        {topDrivers.length > 0 ? (
          <Grid container spacing={2}>
            {topDrivers.map(
              ({ driver, completedJobs, averageRating }, index) => (
                <Grid key={driver.id} xs={12} sm={6} md={4} lg={2.4} spacing={2}>
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: 1,
                      border: `1px solid ${colors.neutral2}20`,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      ...(index === 0 && {
                        border: `2px solid ${colors.accent1}`,
                        boxShadow: `0 4px 12px ${colors.accent1}30`,
                        "&::before": {
                          content: '"Top Driver"',
                          position: "absolute",
                          top: -10,
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: colors.accent1,
                          color: "white",
                          fontSize: "0.75rem",
                          fontWeight: "bold",
                          padding: "2px 8px",
                          borderRadius: 12
                        }
                      })
                    }}
                  >
                    <Box sx={{ position: "absolute", top: 10, left: 10 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          bgcolor:
                            index === 0 ? colors.accent1 : colors.neutral2,
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.875rem",
                          fontWeight: "bold"
                        }}
                      >
                        {index + 1}
                      </Typography>
                    </Box>
                    <Avatar
                      src={driver.profilePicture}
                      alt={`${driver.firstName} ${driver.lastName}`}
                      sx={{
                        width: 64,
                        height: 64,
                        mb: 1,
                        ...(index === 0 && {
                          border: `2px solid ${colors.accent1}`
                        })
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: colors.primary,
                        textAlign: "center"
                      }}
                    >
                      {driver.firstName} {driver.lastName}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 0.5,
                        mt: 1
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: colors.neutral3 }}
                      >
                        Completed Jobs: {completedJobs || 0}
                      </Typography>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        {renderStars(averageRating)}
                        <Typography
                          variant="caption"
                          sx={{ color: colors.neutral3 }}
                        >
                          ({averageRating})
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              )
            )}
          </Grid>
        ) : (
          <Typography align="center">
            No Data Currently Available for selected time period, please check
            again later...
          </Typography>
        )}
      </SectionCard>
    </Grid>
  );
};

export default TopDriversLeaderboard;